import type { ReactNode } from 'react';
import { useCallback } from 'react';

import { FormSelect } from '@/_components';
import type { RSelectProps } from '@/_components';

import { supportStatusOptions } from '../schemas/support-query-schema';

type StatusOption = {
  value: string;
  label: string;
};

type FormSupportStatusMultiSelectProps = Omit<RSelectProps<StatusOption, true>, 'options' | 'isMulti'> & {
  formItemClassName?: string;
  menuListClassName?: string;
};

export function FormSupportStatusMultiSelect(props: FormSupportStatusMultiSelectProps) {
  const getOptionLabel = useCallback((option: StatusOption): ReactNode => {
    return option.label;
  }, []);

  const options = supportStatusOptions.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  return <FormSelect {...props} options={options} isMulti getOptionLabel={getOptionLabel} menuPortalTarget={null} />;
}
